import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormField,
  FormGroup,
  Dropdown,
  Input,
  Button
} from 'semantic-ui-react'

const CardPayRollUX = (props: any) => {
    return(
      <div
        id="CardPayRollUX-div-0"
        style={{paddingBottom: '40px', marginTop: '40px'}}>
        <div
          id="CardPayRollUX-div-4"
          style={{ paddingLeft:'20px', fontWeight: 'bold' }}>
          
          <div
            style={{ display: "flex",  justifyContent: "space-between", position: "relative" }}>
            {}
            <div>
              {props.languageUX === "en" ? "Setting About payroll details" : "การตั้งค่าเกี่ยวกับรายละเอียดการจ่ายเงินเดือน"}
            </div>
            <div
              style={{position: 'absolute',  right: 0, bottom: 0}}>
              {props.editedInformation}
            </div>
          </div>
          <hr
            id="CardPayRollUX-hr-7">
          </hr>
          <div
            id="CardPayRollUX-div-5"
            style={ { marginTop: '10px', border: '1px solid #ccc', padding: '15px' }}>
            
            <div
              id="CardPayRollUX-div-9"
              style={{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px', marginBottom: '5px' }}>
              {props.languageUX === "en" ? "General Detail" : "รายละเอียดทั่วไป"}
            </div>
            <hr
              id="CardPayRollUX-hr-14">
            </hr>
            <FormGroup
              id="CardPayRollUX-FormGroup-17">
              <FormField
                id="CardPayRollUX-FormField-18"
                style={{ display: "flex", alignItems: "center", marginTop:"15px" }}>
                <div
                  id="CardPayRollUX-div-250"
                  style={{display: "inline-block", minWidth: "150px"}}>
                  
                  <div
                    id="CardPayRollUX-div-248"
                    style={{position: "relative", display: "inline-block", marginRight: "5px"}}>
                    
                    <label
                      id="CardPayRollUX-label-22"
                      style={{display: "inline-block"}}>
                      {props.languageUX === "en" ? "Tax ID" : "หมายเลขประจำตัวผู้เสียภาษี"}
                    </label>
                    <label
                      id="CardPayRollUX-label-24"
                      style={{color: "red", position: "absolute", top: "-4px", right: "-10px"}}>
                      *
                    </label>
                  </div>
                </div>
                <div
                  id="CardPayRollUX-div-228"
                  style={{ display: 'flex', gap: '4px', marginLeft: '8px' }}>
                  {props.renderTaxInputs()}
                </div>
                <div
                  id="CardPayRollUX-div-235"
                  style={{ marginLeft: "5px" }}>
                  {props.handleRequiredTaxIDFieldAlert}
                </div>
              </FormField>
              <div
                id="CardPayRollUX-div-43"
                style={{display: "flex", justifyContent: "space-between", whiteSpace: "nowrap" }}>
                
                <FormField
                  id="CardPayRollUX-FormField-44"
                  style={{paddingTop: "20px"}}>
                  <div
                    id="CardPayRollUX-div-46"
                    style={{ display: "flex", alignItems: "center" }}>
                    
                    <div
                      id="CardPayRollUX-div-48"
                      style={{display: 'inline-block', minWidth: '158px'}}>
                      
                      <div
                        id="CardPayRollUX-div-249"
                        style={{position: "relative", display: "inline-block", marginRight: "5px"}}>
                        
                        <label
                          id="CardPayRollUX-label-51"
                          style={{display: "inline-block"}}>
                          {props.languageUX === "en" ? "Organization From" : "องค์กรจาก"}
                        </label>
                        <label
                          id="CardPayRollUX-label-52"
                          style={{color: "red", position: "absolute", top: "-4px", right: "-10px"}}>
                          *
                        </label>
                      </div>
                    </div>
                    <Dropdown
                      id="CardPayRollUX-Dropdown-55"
                      onChange={props.handleOnChangeOrganizationForm}
                      options={props.organizationFromOptions}
                      selection={true}
                      style={{ width: '500px', fontWeight: 'normal'}}
                      value={props.payrollDetailSetting.organization_form}>
                    </Dropdown>
                    <div
                      id="CardPayRollUX-div-236"
                      style={{marginLeft: "5px"}}>
                      {props.handleRequiredOrganizationFormFieldAlert}
                    </div>
                  </div>
                </FormField>
                <FormField
                  id="CardPayRollUX-FormField-45"
                  style={{paddingTop: "20px"}}>
                  <div
                    id="CardPayRollUX-div-47"
                    style={{ display: "flex", alignItems: "center" }}>
                    
                    <div
                      id="CardPayRollUX-div-254"
                      style={{display: "inline-block", minWidth: "150px"}}>
                      
                      <div
                        id="CardPayRollUX-div-49"
                        style={{position: "relative", display: "inline-block", marginRight: "5px"}}>
                        
                        <label
                          id="CardPayRollUX-label-53"
                          style={ {display: "inline-block"}}>
                          {props.languageUX === "en" ? "Business Type" : "ประเภทธุรกิจ"}
                        </label>
                        <label
                          id="CardPayRollUX-label-54"
                          style={{color: "red", position: "absolute", top: "-4px", right: "-10px"}}>
                          *
                        </label>
                      </div>
                    </div>
                    <Dropdown
                      id="CardPayRollUX-Dropdown-56"
                      onChange={props.handleOnChangeBusinessType}
                      options={props.businessTypeOptions}
                      selection={true}
                      style={{ width: '500px', fontWeight: 'normal'}}
                      value={props.payrollDetailSetting.business_type}>
                    </Dropdown>
                    <div
                      id="CardPayRollUX-div-237"
                      style={{marginLeft: "5px"}}>
                      {props.handleRequiredBusinessTypeFieldAlert}
                    </div>
                  </div>
                </FormField>
              </div>
              <div
                id="CardPayRollUX-div-57"
                style={{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }}>
                
                <FormField
                  id="CardPayRollUX-FormField-58"
                  style={{paddingTop: "20px"}}>
                  <div
                    id="CardPayRollUX-div-60"
                    style={{ display: "flex", alignItems: "center" }}>
                    
                    <div
                      id="CardPayRollUX-div-251"
                      style={{display: 'inline-block', minWidth: '158px'}}>
                      
                      <div
                        id="CardPayRollUX-div-61"
                        style={{position: "relative", display: "inline-block", marginRight: "5px"}}>
                        
                        <label
                          id="CardPayRollUX-label-64"
                          style={{display: "inline-block"}}>
                          {props.languageUX === "en" ? "Hospital Name (TH)" : "ชื่อโรงพยาบาล (TH)"}
                        </label>
                        <label
                          id="CardPayRollUX-label-65"
                          style={{color: "red", position: "absolute", top: "-4px", right: "-10px"}}>
                          *
                        </label>
                      </div>
                    </div>
                    <Input
                      id="CardPayRollUX-Input-74"
                      onChange={props.handleOnChangeHospitalNameTh}
                      placeholder="Please fill in Hospital Name"
                      style={{ width: '500px' }}
                      value={props.payrollDetailSetting.hospital_name_th}>
                    </Input>
                    <div
                      id="CardPayRollUX-div-238"
                      style={{marginLeft: "5px"}}>
                      {props.handleRequiredHospitalNameTHFieldAlert}
                    </div>
                  </div>
                </FormField>
                <FormField
                  id="CardPayRollUX-FormField-59"
                  style={{paddingTop: "20px"}}>
                  <div
                    id="CardPayRollUX-div-62"
                    style={{ display: "flex", alignItems: "center" }}>
                    
                    <div
                      id="CardPayRollUX-div-255"
                      style={{display: "inline-block", minWidth: "150px"}}>
                      
                      <div
                        id="CardPayRollUX-div-63"
                        style={{position: "relative", display: "inline-block", marginRight: "5px"}}>
                        
                        <label
                          id="CardPayRollUX-label-66"
                          style={{ paddingRight: "5px", display: "inline-block"}}>
                          {props.languageUX === "en" ? "Hospital Size" : "ขนาดของโรงพยาบาล"}
                        </label>
                      </div>
                    </div>
                    <Dropdown
                      id="CardPayRollUX-Dropdown-68"
                      onChange={props.handleOnChangeHospitalSize}
                      options={props.hospitalSizeOptions}
                      selection={true}
                      style={{width: '500px', fontWeight: 'normal'}}
                      value={props.payrollDetailSetting.hospital_size}>
                    </Dropdown>
                    <div
                      id="CardPayRollUX-div-239"
                      style={{marginLeft: "5px"}}>
                      {props.handleSpaceForHospitalSize}
                    </div>
                  </div>
                </FormField>
              </div>
              <FormField
                id="CardPayRollUX-FormField-70"
                style={{paddingTop: "20px"}}>
                <div
                  id="CardPayRollUX-div-242"
                  style={{display: "flex", alignItems: "center"}}>
                  
                  <div
                    id="CardPayRollUX-div-253"
                    style={{display: 'inline-block', minWidth: '158px'}}>
                    
                    <div
                      id="CardPayRollUX-div-252"
                      style={{position: "relative", display: "inline-block", marginRight: "5px"}}>
                      
                      <label
                        id="CardPayRollUX-label-71"
                        style={{display: "inline-block"}}>
                        {props.languageUX === "en" ? "Hospital Name (ENG)" : "ชื่อโรงพยาบาล (ENG)"}
                      </label>
                      <label
                        id="CardPayRollUX-label-72"
                        style={{color: "red", position: "absolute", top: "-4px", right: "-10px"}}>
                        *
                      </label>
                    </div>
                  </div>
                  <Input
                    id="CardPayRollUX-Input-73"
                    onChange={props.handleOnChangeHospitalNameEn}
                    placeholder="Please fill in Hospital Name"
                    style={{width: '500px'}}
                    value={props.payrollDetailSetting.hospital_name_en}>
                  </Input>
                  <div
                    id="CardPayRollUX-div-246"
                    style={{marginLeft: "5px"}}>
                    {props.handleRequiredHospitalNameENFieldAlert}
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <div
              id="CardPayRollUX-div-77"
              style={{ paddingTop: '15px'}}>
              
              <div
                id="CardPayRollUX-div-78"
                style={{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px'  }}>
                {props.languageUX === "en" ? "Contact Information" : "ข้อมูลการติดต่อ"}
              </div>
              <hr
                id="CardPayRollUX-hr-79">
              </hr>
              <div
                id="CardPayRollUX-div-80"
                style={{ maxWidth: '100%', width: '100%', marginTop:'15px' }}>
                
                <FormGroup
                  id="CardPayRollUX-FormGroup-81"
                  style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  <FormField
                    id="CardPayRollUX-FormField-82">
                    <div
                      id="CardPayRollUX-div-87">
                      {props.renderEmailInputs()}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-103">
                    <div
                      id="CardPayRollUX-div-104">
                      {props.renderMobileInputs()}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-111">
                    <div
                      id="CardPayRollUX-div-112">
                      {props.renderFaxInputs()}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-119">
                    <div
                      id="CardPayRollUX-div-123"
                      style={{ display: "flex", alignItems: "center", marginTop: '4px'}}>
                      
                      <label
                        id="CardPayRollUX-label-125"
                        style={{width: '60px'}}>
                        {props.languageUX === "en" ? "Website" : "เว็บไซต์"}
                      </label>
                      <div
                        id="CardPayRollUX-div-124">
                        
                        <Input
                          id="CardPayRollUX-Input-126"
                          onChange={props.handleOnChangeWebsite}
                          placeholder="Please fill in Website"
                          style={{ width: '200px', marginRight: '8px' }}
                          value={props.payrollDetailSetting.website}>
                        </Input>
                      </div>
                    </div>
                  </FormField>
                </FormGroup>
              </div>
            </div>
            <div
              id="CardPayRollUX-div-127"
              style={{ paddingTop: '7px'}}>
              
              <div
                id="CardPayRollUX-div-128"
                style={{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px'  }}>
                {props.languageUX === "en" ? "Registered Address" : "ที่อยู่จดทะเบียน"}
              </div>
              <hr
                id="CardPayRollUX-hr-129">
              </hr>
              <FormGroup
                id="CardPayRollUX-FormGroup-130"
                style={{paddingTop: '5px',  marginTop:'10px'}}>
                <FormField
                  id="CardPayRollUX-FormField-131">
                  <div
                    id="CardPayRollUX-div-132"
                    style={{ display: "flex",  alignItems: "center", marginTop: '4px'}}>
                    
                    <label
                      id="CardPayRollUX-label-133"
                      style={{width: '100px'}}>
                      {props.languageUX === "en" ? "Address (TH)" : "ที่อยู่ (TH)"}
                    </label>
                    <Input
                      id="CardPayRollUX-Input-134"
                      onChange={props.handleOnChangeAddressTh}
                      placeholder="Please fill in Registered Address"
                      style={{ width: '1100px', marginRight: '8px' }}
                      value={props.payrollDetailSetting.address_th}>
                    </Input>
                  </div>
                </FormField>
                <FormField
                  id="CardPayRollUX-FormField-135">
                  <div
                    id="CardPayRollUX-div-136"
                    style={{ display: "flex",  alignItems: "center", marginTop: '4px'}}>
                    
                    <label
                      id="CardPayRollUX-label-137"
                      style={{width: '100px'}}>
                      {props.languageUX === "en" ? "Address (ENG)" : "ที่อยู่ (ENG)"}
                    </label>
                    <Input
                      id="CardPayRollUX-Input-138"
                      onChange={props.handleOnChangeAddressEn}
                      placeholder="Please fill in Registered Address"
                      style={{ width: '1100px', marginRight: '8px' }}
                      value={props.payrollDetailSetting.address_en}>
                    </Input>
                  </div>
                </FormField>
                <div
                  id="CardPayRollUX-div-139"
                  style={{ display: "flex", marginTop: "10px", alignItems: "center" }}>
                  
                  <FormField
                    id="CardPayRollUX-FormField-140">
                    <div
                      id="CardPayRollUX-div-141"
                      style={{ display: "flex", alignItems: "center", marginTop: '10px'}}>
                      
                      <label
                        id="CardPayRollUX-label-142"
                        style={{marginRight: "5px"}}>
                        {props.languageUX === "en" ? "Country" : "ประเทศ"}
                      </label>
                      <div
                        id="CardPayRollUX-div-143">
                        
                        <Dropdown
                          compact={true}
                          id="CardPayRollUX-Dropdown-144"
                          onChange={props.handleCountryChange}
                          options={props.country}
                          search={true}
                          selection={true}
                          style={{ width: '180px', marginRight: '8px', fontWeight: 'normal'  }}
                          value={props.payrollDetailSetting.country}>
                        </Dropdown>
                      </div>
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-145">
                    <div
                      id="CardPayRollUX-div-146"
                      style={{ display: "flex", alignItems: "center", marginTop: '10px'}}>
                      
                      <label
                        id="CardPayRollUX-label-148"
                        style={{marginRight: "5px"}}>
                        {props.languageUX === "en" ? "Province" : "จังหวัด"}
                      </label>
                      <div
                        id="CardPayRollUX-div-147">
                        
                        <Dropdown
                          compact={true}
                          id="CardPayRollUX-Dropdown-149"
                          onChange={props.handleProvinceChange}
                          options={props.provinceList.map((opt: any) => ({ ...opt, value: String(opt.value) }))}
                          search={true}
                          selection={true}
                          style={{ width: '180px', marginRight: '8px', fontWeight: 'normal'  }}
                          value={String(props.payrollDetailSetting.province)}>
                        </Dropdown>
                      </div>
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-150">
                    <div
                      id="CardPayRollUX-div-151"
                      style={{ display: "flex", alignItems: "center", marginTop: '10px'}}>
                      
                      <label
                        id="CardPayRollUX-label-153"
                        style={{marginRight: "5px"}}>
                        {props.languageUX === "en" ? "City" : "เมือง"}
                      </label>
                      <div
                        id="CardPayRollUX-div-152">
                        
                        <Dropdown
                          compact={true}
                          id="CardPayRollUX-Dropdown-154"
                          onChange={props.handleDistrictChange}
                          options={props.districtList.map((d: any) => ({ ...d, value: String(d.value) }))}
                          search={true}
                          selection={true}
                          style={{ width: '180px', marginRight: '8px' , fontWeight: 'normal' }}
                          value={String(props.payrollDetailSetting.sub_district)}>
                        </Dropdown>
                      </div>
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-155">
                    <div
                      id="CardPayRollUX-div-156"
                      style={{ display: "flex", alignItems: "center", marginTop: '10px'}}>
                      
                      <label
                        id="CardPayRollUX-label-158"
                        style={{marginRight: "5px"}}>
                        {props.languageUX === "en" ? "Sub district" : "ตำบล"}
                      </label>
                      <div
                        id="CardPayRollUX-div-157">
                        
                        <Dropdown
                          compact={true}
                          id="CardPayRollUX-Dropdown-159"
                          onChange={props.handleCityChange}
                          options={props.cityList.map((opt: any) => ({ ...opt, value: String(opt.value) }))}
                          search={true}
                          selection={true}
                          style={{ width: '180px', marginRight: '8px' , fontWeight: 'normal' }}
                          value={String(props.payrollDetailSetting.city)}>
                        </Dropdown>
                      </div>
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-160">
                    <div
                      id="CardPayRollUX-div-161"
                      style={{ display: "flex", alignItems: "center", marginTop: '10px'}}>
                      
                      <label
                        id="CardPayRollUX-label-163"
                        style={{marginRight: "5px"}}>
                        {props.languageUX === "en" ? "Postal Code" : "รหัสไปรษณีย์"}
                      </label>
                      <div
                        id="CardPayRollUX-div-162">
                        
                        <Dropdown
                          compact={true}
                          id="CardPayRollUX-Dropdown-164"
                          onChange={props.handleOnChangePostalCode}
                          options={props.cityList.filter((opt: any) => String(opt.value) === String(props.payrollDetailSetting.city)).map((opt: any) => ({ text: opt.zipcode, value: opt.zipcode,  }))}
                          selection={true}
                          style={{ width: '180px', marginRight: '8px', fontWeight: 'normal'  }}
                          value={props.payrollDetailSetting.postal_code}>
                        </Dropdown>
                      </div>
                    </div>
                  </FormField>
                </div>
              </FormGroup>
            </div>
            <div
              id="CardPayRollUX-div-165"
              style={{ paddingTop: '15px'}}>
              
              <div
                id="CardPayRollUX-div-166"
                style={{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px'  }}>
                {props.languageUX === "en" ? "Social Security & Fund Contribution Rate" : "อัตราเงินสมทบประกันสังคมและกองทุน"}
              </div>
              <hr
                id="CardPayRollUX-hr-167">
              </hr>
              <FormGroup
                id="CardPayRollUX-FormGroup-168"
                style={{paddingTop: '5px', marginTop:'10px'}}>
                <FormField
                  id="CardPayRollUX-FormField-169"
                  style={{ display: "flex", alignItems: "center" }}>
                  <label
                    id="CardPayRollUX-label-170"
                    style={{paddingRight: '5px'}}>
                    {props.languageUX === "en" ? "Social Security ID" : "รหัสประกันสังคม"}
                  </label>
                  <div
                    id="CardPayRollUX-div-229"
                    style={{ display: 'flex', gap: '4px' }}>
                    {props.renderSocialSecurityInputs()}
                  </div>
                </FormField>
                <div
                  id="CardPayRollUX-div-172"
                  style={{display: "flex", justifyContent: "space-between", whiteSpace: "nowrap" }}>
                  
                  <FormField
                    id="CardPayRollUX-FormField-173"
                    style={{paddingTop: "20px"}}>
                    <div
                      id="CardPayRollUX-div-174"
                      style={{ display: "flex", alignItems: "center" }}>
                      
                      <div
                        id="CardPayRollUX-div-175"
                        style={{display: 'flex', minWidth: '220px'}}>
                        
                        <label
                          id="CardPayRollUX-label-177">
                          {props.languageUX === "en" ? "Employers Social Security Rate" : "อัตราประกันสังคมของนายจ้าง"}
                        </label>
                      </div>
                      <Input
                        id="CardPayRollUX-Input-179"
                        onChange={props.handleOnChangeEmployerSocialRate}
                        onKeyDown={props.onKeyDownPercentage}
                        style={{ width: '400px'}}
                        value={props.payrollDetailSetting.employer_social_security_rate}>
                      </Input>
                      <label
                        id="CardPayRollUX-label-178"
                        style={{paddingLeft: '5px', marginRight: '10px'}}>
                        %
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-180"
                    style={{paddingTop: "20px"}}>
                    <div
                      id="CardPayRollUX-div-181"
                      style={{ display: "flex", alignItems: "center" }}>
                      
                      <div
                        id="CardPayRollUX-div-182"
                        style={{display: 'flex', minWidth: '220px'}}>
                        
                        <label
                          id="CardPayRollUX-label-183">
                          {props.languageUX === "en" ? "Employers Maximum Amount" : "จำนวนเงินสูงสุดของนายจ้าง"}
                        </label>
                      </div>
                      <Input
                        id="CardPayRollUX-Input-184"
                        onChange={props.handleOnChangeEmployerMaxAmount}
                        onKeyDown={props.onKeyDownFloatOnly}
                        style={{ width: '400px'}}
                        value={props.payrollDetailSetting.employer_maximum_amount}>
                      </Input>
                    </div>
                  </FormField>
                </div>
                <div
                  id="CardPayRollUX-div-186"
                  style={{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }}>
                  
                  <FormField
                    id="CardPayRollUX-FormField-187"
                    style={{paddingTop: "20px"}}>
                    <div
                      id="CardPayRollUX-div-189"
                      style={{ display: "flex", alignItems: "center" }}>
                      
                      <div
                        id="CardPayRollUX-div-190"
                        style={{display: 'flex', minWidth: '220px'}}>
                        
                        <label
                          id="CardPayRollUX-label-193">
                          {props.languageUX === "en" ? "Employees Social Security Rate" : "อัตราประกันสังคมพนักงาน"}
                        </label>
                      </div>
                      <Input
                        id="CardPayRollUX-Input-196"
                        onChange={props.handleOnChangeEmployeeSocialRate}
                        onKeyDown={props.onKeyDownPercentage}
                        style={{ width: '400px'}}
                        value={props.payrollDetailSetting.employee_social_security_rate}>
                      </Input>
                      <label
                        id="CardPayRollUX-label-194"
                        style={{paddingLeft: '5px', marginRight: '10px'}}>
                        %
                      </label>
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayRollUX-FormField-188"
                    style={{paddingTop: "20px"}}>
                    <div
                      id="CardPayRollUX-div-191"
                      style={{ display: "flex", alignItems: "center" }}>
                      
                      <div
                        id="CardPayRollUX-div-192"
                        style={{display: 'flex', minWidth: '220px'}}>
                        
                        <label
                          id="CardPayRollUX-label-195">
                          {props.languageUX === "en" ? "Employees Maximum Amount" : "จำนวนเงินสูงสุดของพนักงาน"}
                        </label>
                      </div>
                      <Input
                        id="CardPayRollUX-Input-197"
                        onChange={props.handleOnChangeEmployeeMaxAmount}
                        onKeyDown={props.onKeyDownFloatOnly}
                        style={{ width: '400px'}}
                        value={props.payrollDetailSetting.employee_maximum_amount}>
                      </Input>
                    </div>
                  </FormField>
                </div>
              </FormGroup>
            </div>
            <div
              id="CardPayRollUX-div-198"
              style={{ paddingTop: '15px'}}>
              
              <div
                id="CardPayRollUX-div-201"
                style={{display: "flex", justifyContent: "space-between", whiteSpace: "nowrap", alignItems: "flex-end" }}>
                
                <div
                  id="CardPayRollUX-div-202"
                  style={{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px' }}>
                  {props.languageUX === "en" ? "Organization Bank Account" : "บัญชีธนาคารขององค์กร"}
                </div>
                <div
                  id="CardPayRollUX-div-231">
                  {props.renderAddPaymentButton()}
                </div>
              </div>
              <hr
                id="CardPayRollUX-hr-200">
              </hr>
              <div
                id="CardPayRollUX-div-207"
                style={{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap',  marginTop:'10px'  }}>
                
                <FormField
                  id="CardPayRollUX-FormField-208"
                  style={{paddingTop: "5px", display: "flex", alignItems: "center" }}>
                  <label
                    id="CardPayRollUX-label-209"
                    style={{paddingRight: '5px'}}>
                    {props.languageUX === "en" ? "Bank Account for Pay Run" : "บัญชีธนาคารสำหรับการจ่ายเงิน"}
                  </label>
                  <Dropdown
                    compact={true}
                    id="CardPayRollUX-Dropdown-210"
                    onChange={props.handleBankAccountChange}
                    options={props.bankAccountData}
                    selection={true}
                    style={{ width: '300px', marginRight: '8px', fontWeight: 'normal' }}
                    value={props.payrollDetailSetting.bank_account_for_pay_run}>
                  </Dropdown>
                  <div
                    id="CardPayRollUX-div-230"
                    style={{ display: 'flex', gap: '4px' }}>
                    {props.renderBankAccountInputs()}
                  </div>
                  <div
                    id="CardPayRollUX-div-256"
                    style={{display: "inline-flex", alignItems: "center", minWidth: "180px"}}>
                    
                    <div
                      id="CardPayRollUX-div-257"
                      style={{position: "relative", display: "inline-block", marginRight: "20px", paddingLeft: "20px"}}>
                      
                      <label
                        id="CardPayRollUX-label-211">
                        {props.languageUX === "en" ? "Pay Run Date" : "วันที่ดำเนินการชำระเงิน"}
                      </label>
                      <label
                        id="CardPayRollUX-label-213"
                        style={{color: "red", position: "absolute", top: "-4px", right: "-10px"}}>
                        *
                      </label>
                    </div>
                    <Dropdown
                      compact={true}
                      id="CardPayRollUX-Dropdown-214"
                      onChange={props.handleOnChangePayRunDate}
                      options={props.payRunDateOptions}
                      selection={true}
                      style={{ width: '180px', marginRight: '8px', fontWeight: 'normal' }}
                      value={props.payrollDetailSetting.pay_run_date}>
                    </Dropdown>
                    <div
                      id="CardPayRollUX-div-247"
                      style={{marginLeft: "5px"}}>
                      {props.handleRequiredPayRunDateFieldAlert}
                    </div>
                  </div>
                </FormField>
              </div>
            </div>
          </div>
          <div
            id="CardPayRollUX-div-233"
            style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
            
            <Button
              color="green"
              id="CardPayRollUX-Button-234"
              onClick={props.handleOnClickDetailSetting}
              style={{alignSelf: 'flex-end', padding: '8px 16px', fontWeight: 'bold'}}>
              {props.languageUX === "en" ? "Save" : "บันทึก"}
            </Button>
          </div>
        </div>
      </div>
    )
}

CardPayRollUX.displayName = "CardPayRollUX";
export default React.memo(CardPayRollUX)

export const screenPropsDefault = {}

/* Date Time : Tue Aug 19 2025 18:35:36 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: '40px', marginTop: '40px'}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft:'20px', fontWeight: 'bold' }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-5"
        },
        "style": {
          "type": "code",
          "value": " { marginTop: '10px', border: '1px solid #ccc', padding: '15px' }"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "hr",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-hr-7"
        }
      },
      "seq": 7,
      "void": true
    },
    {
      "from": null,
      "id": 8,
      "name": "hr",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-hr-8"
        }
      },
      "seq": 8,
      "void": true
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดทั่วไป",
          "valueEN": "General Detail"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px', marginBottom: '5px' }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Form",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Form-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "hr",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-hr-14"
        }
      },
      "seq": 12,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormGroup-17"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-18"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop:\"15px\" }"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขประจำตัวผู้เสียภาษี",
          "valueEN": "Tax ID"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-21"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"normal\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 248,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขประจำตัวผู้เสียภาษี",
          "valueEN": "Tax ID"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-22"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-block\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 248,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", position: \"absolute\", top: \"-4px\", right: \"-10px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", whiteSpace: \"nowrap\" }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-44"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-45"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{display: 'inline-block', minWidth: '158px'}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 254,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", display: \"inline-block\", marginRight: \"5px\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 249,
      "props": {
        "children": {
          "type": "value",
          "value": "องค์กรจาก",
          "valueEN": "Organization From"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-51"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-block\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 249,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-52"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", position: \"absolute\", top: \"-4px\", right: \"-10px\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทธุรกิจ",
          "valueEN": "Business Type"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-53"
        },
        "style": {
          "type": "code",
          "value": " {display: \"inline-block\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-54"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", position: \"absolute\", top: \"-4px\", right: \"-10px\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Dropdown",
      "parent": 46,
      "props": {
        "compact": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-55"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeOrganizationForm"
        },
        "options": {
          "type": "code",
          "value": "props.organizationFromOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '500px', fontWeight: 'normal'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.organization_form"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Dropdown",
      "parent": 47,
      "props": {
        "compact": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-56"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeBusinessType"
        },
        "options": {
          "type": "code",
          "value": "props.businessTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '500px', fontWeight: 'normal'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.business_type"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-58"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-59"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 251,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", display: \"inline-block\", marginRight: \"5px\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 255,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", display: \"inline-block\", marginRight: \"5px\"}",
          "valueEN": ""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อโรงพยาบาล (TH)",
          "valueEN": "Hospital Name (TH)"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-64"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-block\"}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-65"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", position: \"absolute\", top: \"-4px\", right: \"-10px\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "ขนาดของโรงพยาบาล",
          "valueEN": "Hospital Size"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-66"
        },
        "style": {
          "type": "code",
          "value": "{ paddingRight: \"5px\", display: \"inline-block\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Dropdown",
      "parent": 62,
      "props": {
        "compact": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-68"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeHospitalSize"
        },
        "options": {
          "type": "code",
          "value": "props.hospitalSizeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: '500px', fontWeight: 'normal'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.hospital_size"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-70"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อโรงพยาบาล (ENG)",
          "valueEN": "Hospital Name (ENG)"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-72"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", padding: \"5px\" }"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Input",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-73"
        },
        "placeholder": {
          "type": "value",
          "value": "Please fill in Hospital Name"
        },
        "style": {
          "type": "code",
          "value": "{ width: '500px' }"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Input",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-74"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeHospitalNameTh"
        },
        "placeholder": {
          "type": "value",
          "value": "Please fill in Hospital Name"
        },
        "style": {
          "type": "code",
          "value": "{ width: '500px' }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.hospital_name_th"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: '15px'}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลการติดต่อ",
          "valueEN": "Contact Information"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px'  }"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "hr",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-hr-79"
        }
      },
      "seq": 79,
      "void": true
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{ maxWidth: '100%', width: '100%', marginTop:'15px' }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormGroup",
      "parent": 80,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormGroup-81"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', gap: '16px', flexWrap: 'wrap' }"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-82"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderEmailInputs()"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-87"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-103"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderMobileInputs()"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-104"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-111"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderFaxInputs()"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-112"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormField",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-119"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: '4px'}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-124"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "เว็บไซต์",
          "valueEN": "Website"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-125"
        },
        "style": {
          "type": "code",
          "value": "{width: '60px'}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "Input",
      "parent": 124,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-126"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeWebsite"
        },
        "placeholder": {
          "type": "value",
          "value": "Please fill in Website"
        },
        "style": {
          "type": "code",
          "value": "{ width: '200px', marginRight: '8px' }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.website"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: '7px'}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": "ที่อยู่จดทะเบียน",
          "valueEN": "Registered Address"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px'  }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "hr",
      "parent": 127,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-hr-129"
        }
      },
      "seq": 129,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "FormGroup",
      "parent": 127,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormGroup-130"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: '5px',  marginTop:'10px'}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-131"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 131,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  alignItems: \"center\", marginTop: '4px'}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "label",
      "parent": 132,
      "props": {
        "children": {
          "type": "value",
          "value": "ที่อยู่ (TH)",
          "valueEN": "Address (TH)"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-133"
        },
        "style": {
          "type": "code",
          "value": "{width: '100px'}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "Input",
      "parent": 132,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-134"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeAddressTh"
        },
        "placeholder": {
          "type": "value",
          "value": "Please fill in Registered Address"
        },
        "style": {
          "type": "code",
          "value": "{ width: '1100px', marginRight: '8px' }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.address_th"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "FormField",
      "parent": 130,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-135"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 135,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  alignItems: \"center\", marginTop: '4px'}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "label",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "ที่อยู่ (ENG)",
          "valueEN": "Address (ENG)"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-137"
        },
        "style": {
          "type": "code",
          "value": "{width: '100px'}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "Input",
      "parent": 136,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-138"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeAddressEn"
        },
        "placeholder": {
          "type": "value",
          "value": "Please fill in Registered Address"
        },
        "style": {
          "type": "code",
          "value": "{ width: '1100px', marginRight: '8px' }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.address_en"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", marginTop: \"10px\", alignItems: \"center\" }"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-140"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: '10px'}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "label",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเทศ",
          "valueEN": "Country"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-142"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-143"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Dropdown",
      "parent": 143,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-144"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCountryChange"
        },
        "options": {
          "type": "code",
          "value": "props.country"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '180px', marginRight: '8px', fontWeight: 'normal'  }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.country"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-145"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: '10px'}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-147"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "label",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": "จังหวัด",
          "valueEN": "Province"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-148"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "Dropdown",
      "parent": 147,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-149"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleProvinceChange"
        },
        "options": {
          "type": "code",
          "value": "props.provinceList.map((opt: any) => ({ ...opt, value: String(opt.value) }))"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '180px', marginRight: '8px', fontWeight: 'normal'  }"
        },
        "value": {
          "type": "code",
          "value": "String(props.payrollDetailSetting.province)"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-151"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: '10px'}"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-152"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "label",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "เมือง",
          "valueEN": "City"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-153"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "Dropdown",
      "parent": 152,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-154"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleDistrictChange"
        },
        "options": {
          "type": "code",
          "value": "props.districtList.map((d: any) => ({ ...d, value: String(d.value) }))"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '180px', marginRight: '8px' , fontWeight: 'normal' }"
        },
        "value": {
          "type": "code",
          "value": "String(props.payrollDetailSetting.sub_district)"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-155"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: '10px'}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-157"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "label",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำบล",
          "valueEN": "Sub district"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-158"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\"}"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "Dropdown",
      "parent": 157,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-159"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleCityChange"
        },
        "options": {
          "type": "code",
          "value": "props.cityList.map((opt: any) => ({ ...opt, value: String(opt.value) }))"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '180px', marginRight: '8px' , fontWeight: 'normal' }"
        },
        "value": {
          "type": "code",
          "value": "String(props.payrollDetailSetting.city)"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-160"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: '10px'}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-162"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสไปรษณีย์",
          "valueEN": "Postal Code"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-163"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"5px\"}"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "Dropdown",
      "parent": 162,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-164"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangePostalCode"
        },
        "options": {
          "type": "code",
          "value": "props.cityList.filter((opt: any) => String(opt.value) === String(props.payrollDetailSetting.city)).map((opt: any) => ({ text: opt.zipcode, value: opt.zipcode,  }))"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '180px', marginRight: '8px', fontWeight: 'normal'  }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.postal_code"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-165"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: '15px'}"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "value",
          "value": "อัตราเงินสมทบประกันสังคมและกองทุน",
          "valueEN": "Social Security & Fund Contribution Rate"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-166"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px'  }"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "hr",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-hr-167"
        }
      },
      "seq": 167,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "FormGroup",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormGroup-168"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: '5px', marginTop:'10px'}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "FormField",
      "parent": 168,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-169"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "label",
      "parent": 169,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสประกันสังคม",
          "valueEN": "Social Security ID"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-170"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: '5px'}"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", whiteSpace: \"nowrap\" }"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "FormField",
      "parent": 172,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-173"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-174"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex', minWidth: '220px'}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 175,
      "props": {
        "children": {
          "type": "value",
          "value": "อัตราประกันสังคมของนายจ้าง",
          "valueEN": "Employers Social Security Rate"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-177"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "label",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": "%"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-178"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: '5px', marginRight: '10px'}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "Input",
      "parent": 174,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-179"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeEmployerSocialRate"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownPercentage"
        },
        "style": {
          "type": "code",
          "value": "{ width: '400px'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.employer_social_security_rate"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "FormField",
      "parent": 172,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-180"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 180,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-181"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex', minWidth: '220px'}"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "label",
      "parent": 182,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนเงินสูงสุดของนายจ้าง",
          "valueEN": "Employers Maximum Amount"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-183"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "Input",
      "parent": 181,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-184"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeEmployerMaxAmount"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownFloatOnly"
        },
        "style": {
          "type": "code",
          "value": "{ width: '400px'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.employer_maximum_amount"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "div",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-186"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap' }"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormField",
      "parent": 186,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-187"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 186,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-188"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 187,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-189"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 189,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-190"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex', minWidth: '220px'}"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "div",
      "parent": 188,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-191"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 191,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-192"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex', minWidth: '220px'}"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "label",
      "parent": 190,
      "props": {
        "children": {
          "type": "value",
          "value": "อัตราประกันสังคมพนักงาน",
          "valueEN": "Employees Social Security Rate"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-193"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "label",
      "parent": 189,
      "props": {
        "children": {
          "type": "value",
          "value": "%"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-194"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: '5px', marginRight: '10px'}"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "label",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนเงินสูงสุดของพนักงาน",
          "valueEN": "Employees Maximum Amount"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-195"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "Input",
      "parent": 189,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-196"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeEmployeeSocialRate"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownPercentage"
        },
        "style": {
          "type": "code",
          "value": "{ width: '400px'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.employee_social_security_rate"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Input",
      "parent": 191,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-197"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeEmployeeMaxAmount"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownFloatOnly"
        },
        "style": {
          "type": "code",
          "value": "{ width: '400px'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.employee_maximum_amount"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": null,
      "id": 198,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-198"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: '15px'}"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "hr",
      "parent": 198,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-hr-200"
        }
      },
      "seq": 201,
      "void": true
    },
    {
      "from": null,
      "id": 201,
      "name": "div",
      "parent": 198,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-201"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", whiteSpace: \"nowrap\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 202,
      "name": "div",
      "parent": 201,
      "props": {
        "children": {
          "type": "value",
          "value": "บัญชีธนาคารขององค์กร",
          "valueEN": "Organization Bank Account"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-202"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: '#b6dcdb', borderRadius: '6px', padding: '5px 15px', textAlign: 'left', width: '300px',  marginBottom: '5px' }"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 207,
      "name": "div",
      "parent": 198,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-207"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', justifyContent: 'space-between', whiteSpace: 'nowrap',  marginTop:'10px'  }"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 208,
      "name": "FormField",
      "parent": 207,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-208"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"5px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": null,
      "id": 209,
      "name": "label",
      "parent": 208,
      "props": {
        "children": {
          "type": "value",
          "value": "บัญชีธนาคารสำหรับการจ่ายเงิน",
          "valueEN": "Bank Account for Pay Run"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-209"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: '5px'}"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 210,
      "name": "Dropdown",
      "parent": 208,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-210"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleBankAccountChange"
        },
        "options": {
          "type": "code",
          "value": "props.bankAccountData"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '300px', marginRight: '8px', fontWeight: 'normal' }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.bank_account_for_pay_run"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": null,
      "id": 211,
      "name": "label",
      "parent": 257,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ดำเนินการชำระเงิน",
          "valueEN": "Pay Run Date"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-211"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": null,
      "id": 213,
      "name": "label",
      "parent": 257,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-213"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", position: \"absolute\", top: \"-4px\", right: \"-10px\"}"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 214,
      "name": "Dropdown",
      "parent": 256,
      "props": {
        "compact": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Dropdown-214"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangePayRunDate"
        },
        "options": {
          "type": "code",
          "value": "props.payRunDateOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: '180px', marginRight: '8px', fontWeight: 'normal' }"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.pay_run_date"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 228,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderTaxInputs()"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-228"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', gap: '4px', marginLeft: '8px' }"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": null,
      "id": 229,
      "name": "div",
      "parent": 169,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderSocialSecurityInputs()"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-229"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', gap: '4px' }"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "div",
      "parent": 208,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderBankAccountInputs()"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-230"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', gap: '4px' }"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": null,
      "id": 231,
      "name": "div",
      "parent": 201,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderAddPaymentButton()"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-231"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 233,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-233"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 234,
      "name": "Button",
      "parent": 233,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Button-234"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleOnClickDetailSetting"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{alignSelf: 'flex-end', padding: '8px 16px', fontWeight: 'bold'}"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 235,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.handleRequiredTaxIDFieldAlert"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-235"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"5px\" }"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "props.handleRequiredOrganizationFormFieldAlert"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-236"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": null,
      "id": 237,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "code",
          "value": "props.handleRequiredBusinessTypeFieldAlert"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-237"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 238,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.handleRequiredHospitalNameTHFieldAlert"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-238"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 239,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "code",
          "value": "props.handleSpaceForHospitalSize"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-239"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 240,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "div"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-240"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 241,
      "name": "FormField",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-FormField-70"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px\"}"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 241,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-242"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "label",
      "parent": 252,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อโรงพยาบาล (ENG)",
          "valueEN": "Hospital Name (ENG)"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-71"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-block\"}"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "label",
      "parent": 252,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-label-72"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", position: \"absolute\", top: \"-4px\", right: \"-10px\"}"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 245,
      "name": "Input",
      "parent": 242,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayRollUX-Input-73"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleOnChangeHospitalNameEn"
        },
        "placeholder": {
          "type": "value",
          "value": "Please fill in Hospital Name"
        },
        "style": {
          "type": "code",
          "value": "{width: '500px'}"
        },
        "value": {
          "type": "code",
          "value": "props.payrollDetailSetting.hospital_name_en"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 242,
      "props": {
        "children": {
          "type": "code",
          "value": "props.handleRequiredHospitalNameENFieldAlert"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-246"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "div",
      "parent": 256,
      "props": {
        "children": {
          "type": "code",
          "value": "props.handleRequiredPayRunDateFieldAlert"
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-247"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "div",
      "parent": 250,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-248"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", display: \"inline-block\", marginRight: \"5px\"}"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": null,
      "id": 249,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-249"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", display: \"inline-block\", marginRight: \"5px\"}"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-250"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-block\", minWidth: \"150px\"}"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-251"
        },
        "style": {
          "type": "code",
          "value": "{display: 'inline-block', minWidth: '158px'}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 253,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-252"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", display: \"inline-block\", marginRight: \"5px\"}"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-253"
        },
        "style": {
          "type": "code",
          "value": "{display: 'inline-block', minWidth: '158px'}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-254"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-block\", minWidth: \"150px\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-255"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-block\", minWidth: \"150px\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "div",
      "parent": 208,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-256"
        },
        "style": {
          "type": "code",
          "value": "{display: \"inline-flex\", alignItems: \"center\", minWidth: \"180px\"}"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 257,
      "name": "div",
      "parent": 256,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayRollUX-div-257"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", display: \"inline-block\", marginRight: \"20px\", paddingLeft: \"20px\"}"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  justifyContent: \"space-between\", position: \"relative\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": "การตั้งค่าเกี่ยวกับรายละเอียดการจ่ายเงินเดือน",
          "valueEN": "Setting About payroll details"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editedInformation"
        },
        "style": {
          "type": "code",
          "value": "{position: 'absolute',  right: 0, bottom: 0}"
        }
      },
      "seq": 262,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 95,
  "memo": true,
  "name": "CardPayRollUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 75
}

*********************************************************************************** */
